$ ->
  # Filter
  $('a', '#js-filter').on 'click', (e) ->
    e.preventDefault()
    $this = $(this)
    targetChurch = $this.attr('href').replace('#', '')
    $allChurches = $('[data-church]')
    $selectedChurches = $('[data-church='+targetChurch+']')

    $('a', '#js-filter').removeClass('active')  # Überall die Klasse "active" entfernen
    $this.addClass('active')                    # Dem angeklickten die Klasse "active" hinzufügen
    $allChurches.removeClass('visible').addClass('hidden')
    $selectedChurches.removeClass('hidden').addClass('visible')
    $('.institution--reset').removeClass('hidden').addClass('visible')

  # Filter deaktivieren
  $('.institution--reset', '#js-filter').on 'click', (e) ->
    e.preventDefault()
    $this = $(this)

    $('a', '#js-filter').removeClass('active')
    $('[data-church]').removeClass('hidden').addClass('visible')
    $this.removeClass('visible').addClass('hidden')



// WEBPACK FOOTER //
// ./Components/filter.coffee